
export default function WorkingHourComponent({ formData }) {
    const getTime = (timeString) => {
        const [hour, minutes] = timeString.split(':').map(Number);

        if (isNaN(hour) || isNaN(minutes) || hour < 0 || hour > 23 || minutes < 0 || minutes > 59) {
            return "Invalid Time";
        }

        const amPm = hour >= 12 ? 'PM' : 'AM';
        const formattedHours = hour % 12 || 12; // Convert to 12-hour format
        const formattedMinutes = String(minutes).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes} ${amPm}`;
    };

    return (
        <div>
            {
                Array.isArray(formData?.working_hours) && formData?.working_hours?.map((item, index) => (
                    <p>{getTime(item?.start_time)} - {getTime(item?.end_time)}</p>
                ))
            }
        </div>
    )
}
